import React from 'react';
import Base from 'client/components/base';

export default class Notification extends Base {
  render() {
    return <div className={this.getCSSClasses()}>{this.props.title}</div>;
  }

  getCSSClasses() {
    let classString = this.css();
    if ('variant' in this.props && this.props.variant.length != 0) {
      classString += ' ' + this.props.variant;
    }

    return classString;
  }
}



// WEBPACK FOOTER //
// ./client/components/common/notification/notification.es6